<template>
  <button class="wpp-button" title="Entrar em contato com suporte" @click="openWhatsApp">
    <Whatsapp :size="54"></Whatsapp>
  </button>
</template>

<script>
import Whatsapp from 'icons/Whatsapp'

export default {
  name: 'WhatsappButton',
  components: {
    Whatsapp,
  },
  data() {
    return {
      role: Number(localStorage.id_role),
      nomeFantasia: localStorage.nome_fantasia,
    }
  },
  methods: {
    openWhatsApp() {
      const phone = process.env.VUE_APP_SUPORTE_NUMBER
      let message = ''

      if ([1, 5].includes(this.role)) {
        message = encodeURIComponent(`Olá, sou da ${this.nomeFantasia}. Pode me ajudar?`)
      } else {
        message = encodeURIComponent(`Olá, me chamo ${localStorage.nome}, sou aluno da ${this.nomeFantasia}. Pode me ajudar?`)
      }

      const url = `https://wa.me/${phone}?text=${message}`

      window.open(url, "_blank")
    },
  }
}
</script>

<style lang="scss" scoped>
.wpp-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
}
</style>